import React from 'react';
import { PropTypes } from 'prop-types';
import OrderStop from './components/OrderStop';
import { appointmentRequired } from 'utils/order';
import { selectors as orderSelectors } from 'state/order';
import { useSelector } from 'react-redux';
import OrderStopContextProvider from 'components/orders/OrderStop/UseOrderStop';
import orderConstants from 'utils/order/constants';

const OrderSummary = ({ className, stops: stopsInProps, isRecurring }) => {
  const orderType = useSelector(orderSelectors.getTypeOfOrder);
  const stopsInOrder = useSelector(orderSelectors.getStopsInOrder) || [];
  const stops = stopsInProps || stopsInOrder;
  const firstStop = stops[0];

  const shipmentKeys = useSelector((state) =>
    orderSelectors.getShipmentKeys(state)
  );

  return (
    <ul className={className} data-testid="order-summary">
      {stops.map((stop, index) => {
        const shipmentKey =
          orderConstants.COLLECTION === orderType
            ? shipmentKeys[index] || shipmentKeys[index - 1]
            : shipmentKeys[index - 1] || shipmentKeys[index];
        const stopType = stop?.stop_type;
        const forcePendingAppointment = appointmentRequired({
          orderType,
          stopType,
          poi_info: stop?.address?.poi_info,
        });

        return (
          <OrderStopContextProvider
            key={index}
            stop={stop}
            firstStop={firstStop}
            isRecurring={isRecurring}
            isLastStop={index < stops.length - 1}
          >
            <OrderStop
              stops={stops}
              shipmentKey={shipmentKey}
              stopType={stopType}
              forcePendingAppointment={forcePendingAppointment}
            />
          </OrderStopContextProvider>
        );
      })}
    </ul>
  );
};

OrderSummary.propTypes = {
  className: PropTypes.string,
  stops: PropTypes.arrayOf(PropTypes.object),
  isRecurring: PropTypes.bool,
};

OrderSummary.defaultProps = {
  isRecurring: false,
};

export default OrderSummary;
